import React, { useState, useEffect } from "react";
import {
  Elements,
  CardElement,
  useElements,
  useStripe,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import DEATH_API from "../../apis/death.api";
import Loader from "../../components/styled-components/loader/loader";
import swal from "sweetalert";
import { useHistory, useLocation } from "react-router-dom";
import "./checkoutForm.css";
import Tap from "@tapfiliate/tapfiliate-js";
import PhoneNumber from "../../components/form/components/Countrycode";
const stripePromise = loadStripe("pk_live_wKCw9yisXYK24d46u573Nhql00SmHvFQlO"); // live key
// const stripePromise = loadStripe("pk_test_51RP1DoFPCqXGd6eyq2L1o2Gu7y7vY5fuVNqoo6McnegHn7aS9heWWhYSQFJtoyxLYXpovlblPAuhKfrX04vb2fLO00MYnsmyJS"); // stage key


const PaymentForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const history = useHistory();
  const location = useLocation();
  console.log(
    "params",
    location.state && location.state.from && location.state.from.search
  );
  let searchParams =
    location.state && location.state.from && location.state.from.search;
  const urlParams = new URLSearchParams(searchParams);
  const paymentParam = urlParams.get("payment"); // 12344
  const packageParam = urlParams.get("package"); // new

  console.log("Payment:", paymentParam);
  console.log("Package:", packageParam);
  const [selectedPayment, setSelectedPayment] = useState(
    packageParam ? packageParam : "yearly"
  );
  const [paymentValue, setPaymentValue] = useState(
    paymentParam ? paymentParam : "99.95"
  );
  const [loading, setLoading] = useState(false);
  const [productId, setProductId] = useState(null);
  const [productList, setProductList] = useState(null);
  const [interval, setinterval] = useState("month");
  const [promoPayment, setPromoPayment] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not loaded yet. Make sure to disable
      // form submission until Stripe.js has loaded.
      return;
    }
    const formattedPhone = phone && phone.replace(/\s+/g, '');
    const payload = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
      billing_details: {
        name: name && name,
        phone: formattedPhone && formattedPhone, 
      },
      metadata: {
        promo_code: promotionCode, // Apply the promotion code
      },
    });
    console.log("[PaymentMethod]", payload);
    if (payload) {
      stripePaymentConfig(payload);
    }
  };

  const stripePaymentConfig = async (payload) => {
    console.log("paymentMethod in stripe", payload);

    if (payload && payload.paymentMethod && payload.paymentMethod.id) {
      try {
        setLoading(true);
        const product = productList && productList.find(item => item.interval === interval);
        console.log("product",product)
        let api_res = await DEATH_API.stripePayment({
          paymentMethod: payload && payload.paymentMethod.id,
          // amount: paymentValue && paymentValue * 100,
          // subType: selectedPayment && selectedPayment,
          productId:product ? product.productId : null,
          productName:product ? product.productName : null,
          // productList && interval === "year"
          //   ? productList[1].productName
          //   : productList[0].productName,
          couponCode: promotionCode && promotionCode,
          interval: interval && interval,
        });
        console.log("api_res", api_res);
        if (api_res.status === 200) {
          // await createListing(api_res.subscriptionId, api_res.message);
          if (api_res.User.roles) {
            localStorage.setItem(
              "role",
              JSON.stringify(api_res.User.roles[0].name)
            );
            let permissions = api_res.User.roles[0].permissions;
            const namesArray = Object.values(permissions).map(
              (permission) => permission.name
            );
            console.log("namesArray", namesArray);
            localStorage.setItem("permissionState", JSON.stringify(namesArray));
            swal("Success", api_res.message, "success");
            const userName = localStorage.getItem("userName") && localStorage.getItem("userName");
            if(userName){
              Tap.conversion(userName, parseFloat(paymentValue));
            }
            history.push("/dashboard");
          }
        }
        if (api_res.status === 400) {
          swal("Error", api_res.error, "error");
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error..... here in catch", error);
        // swal("Error", error.error, "error");
        // throw new Error(error);
      }
    } else {
      swal("Error", payload.error.message, "error");
    }
  };

  const createListing = async (subscriptionId, message) => {
    try {
      setLoading(true);
      let api_res = await DEATH_API.subscriptionDetails({
        subId: subscriptionId && subscriptionId,
      });
      console.log("api_res", api_res);
      if (api_res.status === 200) {
        swal("Success", message, "success");
        // history.push("/subscription");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      // throw new Error(error);
    }
  };
  const applyPromoCode = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);
      const product = productList && productList.find(item => item.interval === interval);
      let api_res = await DEATH_API.promoCodeDetails({
        productId:product ? product.productId : null,
        couponCode: promotionCode && promotionCode,
      });
      console.log("api_res", api_res);
      if (api_res.status === 200) {
        setPromoPayment(api_res.data);
        swal("Success", api_res.message, "success");
      } 
      if (api_res.status === 400) {
        swal("Error", api_res.error, "error");
      } 
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("errrooror",error);
    }
  };
  const stripeProducts = async () => {
    try {
      setLoading(true);
      let api_res = await DEATH_API.getStripeProductsList();
      console.log("api_res stripe Products", api_res);
      if (api_res.data) {
        setProductList(api_res.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      // throw new Error(error);
    }
  };
  useEffect(() => {
    stripeProducts();
  }, []);
  const [promotionCode, setPromotionCode] = useState("");

  const handlePromotionCodeChange = (event) => {
    setPromotionCode(event.target.value);
  };

  const handlePaymentSelect = (
    name,
    value,
    interval,
    productId,
    productName
  ) => {
    setSelectedPayment(name);
    setPaymentValue(value);
    setinterval(interval);
    setProductId({ productId: productId, productName: productName });
  };
  const inputStyle = {
    iconColor: "#c4f0ff",
    color: "black",
    fontWeight: "500",
    fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
    fontSize: "16px",
    fontSmoothing: "antialiased",
    ":-webkit-autofill": {
      WebkitTextFillColor: "black",
      // transition: "background-color 5000s ease-in-out 0s",
    },
    "::placeholder": {
      color: "#C1C1C7",
    },

    invalid: {
      iconColor: "#FFC7EE",
      color: "red",
    },
  };
  return (
    <React.Fragment>
      <div className="checkoutCardHeading">Payment Options</div>
      <div className="checkoutCardsubHeading">
        Your card will not be charged until day 31. Cancel Anytime{" "}
      </div>
      <div className="paymentcardsMain">
        {productList &&
          productList.map((item, index) => (
            <div key={index} className="paymentcards">
              <div
                className="paymentcardsMainInner"
                onClick={() => {
                  handlePaymentSelect(
                    "yearly",
                    item.amount,
                    item.interval,
                    item.productId,
                    item.productName
                  );
                }}
                style={{
                  background:
                    item.interval && item.interval === interval
                      ? "#E1E4ED"
                      : "transparent",
                  color:
                    item.interval && item.interval === interval
                      ? "#2A3DA3"
                      : "#6D758F",
                }}
              >
                <div className="paymentcardsHeading">
                    Monthly
                </div>
                <div className="paymentcardsValue">
                  ${item.amount && item.amount}{" "}
                  <span className="paymenttype">
                    /monthly
                  </span>
                </div>
                { /*item.interval && item.interval === "month" ? (
                  <ul style={{ listStyle: "inside", marginTop: "1rem" }}>
                    <li className="paymentcardslist">
                      Renewal after 1 year $14.95 per month
                    </li>
                  </ul>
                ) : (
                  <ul style={{ listStyle: "inside", marginTop: "1rem" }}>
                    <li className="paymentcardslist">
                      Renewal after 1 year $149.95
                    </li>
                    <li className="paymentcardslist">Save $49.45</li>
                  </ul>
                ) */}
              </div>
            </div>
          ))}
      </div>

      <form style={{ width: "100%" }} 
      // onSubmit={handleSubmit}
      >
      <label className="labelStyleCheckout"  style={{ display: "inline-grid" }}>
      Name
      <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
      <input
        type="text"
        value={name}
        style={{width:"100%"}}
        className="inputStylepromo"
        onChange={(e) => setName(e.target.value)}
        placeholder="Your Name"
        required
      />
      </div>
    </label>
    <label className="labelStyleCheckout" style={{ display: "inline-grid" }}>
    Phone Number
      <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
        <PhoneNumber
          id="stripePhone"
          name="phone"
          onChange={(e) => {setPhone(e.target.value); console.log("phone", phone)}}
          size="large"
          className="inputStylepromo"
          placeholder="Phone Number"
          style={{width:"100%"}}
          required
          ></PhoneNumber>
      </div>
    </label>

        <label className="labelStyleCheckout">
          Credit Card Number
          <div className="inputStyleCheckout">
            <CardNumberElement
              options={{
                style: {
                  base: inputStyle,
                },
              }}
              onReady={() => {
                console.log("CardNumberElement [ready]");
              }}
              onChange={(event) => {
                console.log("CardNumberElement [change]", event);
              }}
              onBlur={() => {
                console.log("CardNumberElement [blur]");
              }}
              onFocus={() => {
                console.log("CardNumberElement [focus]");
              }}
            />
          </div>
        </label>
        <label className="labelStyleCheckout">
          Expiration
          <div className="inputStyleCheckout">
            <CardExpiryElement
              options={{
                style: {
                  base: inputStyle,
                },
              }}
              onReady={() => {
                console.log("CardNumberElement [ready]");
              }}
              onChange={(event) => {
                console.log("CardNumberElement [change]", event);
              }}
              onBlur={() => {
                console.log("CardNumberElement [blur]");
              }}
              onFocus={() => {
                console.log("CardNumberElement [focus]");
              }}
            />
          </div>
        </label>
        <label className="labelStyleCheckout">
          CVC
          <div className="inputStyleCheckout">
            <CardCvcElement
              options={{
                style: {
                  base: inputStyle,
                },
              }}
              onReady={() => {
                console.log("CardNumberElement [ready]");
              }}
              onChange={(event) => {
                console.log("CardNumberElement [change]", event);
              }}
              onBlur={() => {
                console.log("CardNumberElement [blur]");
              }}
              onFocus={() => {
                console.log("CardNumberElement [focus]");
              }}
            />
          </div>
        </label>
        <label
          className="labelStyleCheckout"
          style={{ display: "inline-grid" }}
        >
          Promo Code
          <div className="inputStyleCheckoutPromo" style={{ display: "flex" }}>
            <input
              name="promo"
              placeholder="Promo Code"
              className="inputStylepromo"
              onChange={handlePromotionCodeChange}
              style={{ width: "80%" }}
            />
            <button
              className="savebutton"
              style={{
                width: "20%",
                cursor: promotionCode ? "pointer" : "not-allowed",
                opacity: promotionCode ? "1" : "0.3",
              }}
              disabled={promotionCode ? false : true}
              type="submit"
              onClick={applyPromoCode}
            >
              Apply
            </button>
          </div>
        </label>

        <div className="totalPaymentSection">
          <div className="totalPaymentSectioncard">
            <div className="totalpayment1">Today’s Total</div>
            <div>${promoPayment == 0 ? promoPayment : promoPayment && parseFloat(promoPayment).toFixed(2) || paymentValue  && paymentValue}</div>
          </div>
          <div className="totalPaymentSectioncard">
            <div className="totalpayment1">
              {" "}
              Billed after a month
            </div>
            <div>${promoPayment == 0 ? promoPayment : promoPayment && parseFloat(promoPayment).toFixed(2) || paymentValue  && paymentValue}</div>
          </div>
        </div>
        <div style={{display:'flex', justifyContent:'end' , padding:'0 3rem'}}>
          <button
            className="savebutton"
            style={{ marginTop: "1rem", width: "fitContent" }}
            type="submit"
            disabled={!stripe}
            onClick={handleSubmit}
          >
            Subscribe
          </button>
        </div>
      </form>

      <Loader isLoading={loading} />

      {/*<CardElement />
      <button
        className="savebutton"
        style={{ marginTop: "1rem" }}
        onClick={handleSubmit(stripe, elements)}
      >
        Buy
      </button>*/}
    </React.Fragment>
  );
};

const StripePaymentForm = () => (
  <Elements stripe={stripePromise}>
    <div className="checkoutCard">
      <div className="checkoutCardInner">
        <PaymentForm />
      </div>
    </div>
  </Elements>
);

export default StripePaymentForm;
